import usePdpBreadcrumbContext from '../composables/usePdpBreadcrumbContext'

/**
 * ECOM-2383: age the PDP breadcrumb navigation context on every completed
 * client navigation. The context captured on a PLP product-grid click is valid
 * for exactly the following PLP→PDP hop; any later navigation (to search,
 * basket, wishlist, another PDP, browser back/forward) clears it so re-opening
 * the same product from a non-PLP entry falls back to the ECOM-2381 breadcrumb.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter()
  const { ageNavigationContext } = usePdpBreadcrumbContext()

  router?.afterEach(() => {
    ageNavigationContext()
  })
})
